<template>
  <span>
    <select v-if="displayType === 'form'" :disabled="readOnlyProp" name="" class="form-control"
            v-bind:value="modelValue" v-on:change="onChange($event.target.value)">
      <slot></slot>
      <option v-for="agency in agencyList" :value="agency.value" :selected="agency.value === defaultAgency">
        {{ agency.label }}
      </option>
    </select>
    <span v-if="displayType === 'label'">{{ agencyLabel }}</span>
  </span>
</template>

<script>
import CommonDataService from '../endpoints/CommonDataService'
// import OrgAdminService from '../endpoints/admin/OrgAdminService'
export default {
    emits: ['update:modelValue','change'],

  name: 'accred-agency-input',
  props: {
    modelValue: {},
    displayType: {
      type: String,
      default: 'form'
    },
    readOnlyProp: Boolean
  },
  data () {
    return {
      agencyList: []
    }
  },
  computed: {
    defaultAgency () {
      return this.modelValue
    },
    agencyLabel: function () {
      if (this.agencyList && this.agencyList.length > 0) {
        let agency = this.agencyList.find((el) => el.value === this.modelValue)
        if (agency) return agency.label
      }

      return ''
    }
  },
  methods: {
    loadAccredAgencyList: function () {
      let self = this

      // OrgAdminService.loadAccredAgencyList()
      CommonDataService.loadAccredAgencyList()
        .then(response => {
          self.agencyList = response.data
        })
        .catch(error => {
          self.error = error.message
        })
    },
    onChange (value) {
      this.$emit('update:modelValue', value)
        this.$emit('change', value)
    }
  },
  created () {
    this.loadAccredAgencyList()
  }
}
</script>
